import { defineComponent as _, useCssVars as y, unref as e, ref as B, computed as n, openBlock as t, createElementBlock as p, normalizeClass as g, createBlock as i, Fragment as h, createCommentVNode as r, createElementVNode as k, renderSlot as C } from "vue";
import { NovoButtonVariant as I, NovoButtonSize as S, getButtonSideIconSize as N, getButtonMainIconSize as V, getButtonStyleClasses as W, getSpinnerColor as $ } from "./novoui-vuejs50.js";
import { scalarCssValue as x } from "./novoui-vuejs800.js";
import "./novoui-vuejs72.js";
import "./novoui-vuejs3.js";
import "./novoui-vuejs4.js";
import "./novoui-vuejs5.js";
import "./novoui-vuejs6.js";
import "./novoui-vuejs7.js";
import "./novoui-vuejs79.js";
import "./novoui-vuejs80.js";
import "./novoui-vuejs9.js";
import l from "./novoui-vuejs10.js";
import "./novoui-vuejs41.js";
import "./novoui-vuejs12.js";
import "./novoui-vuejs13.js";
import "./novoui-vuejs14.js";
import "./novoui-vuejs15.js";
import "./novoui-vuejs16.js";
import "./novoui-vuejs18.js";
import "./novoui-vuejs19.js";
import "./novoui-vuejs20.js";
import "./novoui-vuejs21.js";
import "./novoui-vuejs22.js";
import "./novoui-vuejs23.js";
import "./novoui-vuejs25.js";
import "./novoui-vuejs26.js";
import "./novoui-vuejs27.js";
import "./novoui-vuejs28.js";
import "./novoui-vuejs29.js";
import "./novoui-vuejs30.js";
import "./novoui-vuejs31.js";
import "./novoui-vuejs32.js";
import "./novoui-vuejs33.js";
import u from "./novoui-vuejs34.js";
import "./novoui-vuejs36.js";
import "./novoui-vuejs110.js";
import "./novoui-vuejs39.js";
import "./novoui-vuejs40.js";
const L = ["disabled", "aria-label"], E = { class: "button-label" }, go = /* @__PURE__ */ _({
  __name: "NButton",
  props: {
    variant: { default: I.fill },
    size: { default: S.medium },
    icon: { default: void 0 },
    rightIcon: { default: void 0 },
    leftIcon: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    square: { type: Boolean, default: !1 },
    forceWidth: { default: void 0 },
    isLoading: { type: Boolean },
    fullWidth: { type: Boolean, default: !1 }
  },
  setup(d, { expose: f }) {
    y((c) => ({
      "3ed068d7": e(b)
    }));
    const o = d, a = B(null), b = x(o.forceWidth);
    f({ buttonRef: a });
    const s = n(() => N(o.size)), z = n(() => V(o.size)), v = n(() => W(o)), m = n(() => $(o.variant));
    return (c, R) => (t(), p("button", {
      type: "button",
      class: g(["button button-primary", v.value]),
      ref_key: "buttonRef",
      ref: a,
      disabled: o.disabled,
      "aria-label": o.icon ? `icon-${o.icon}` : void 0
    }, [
      o.isLoading && o.icon ? (t(), i(e(u), {
        key: 0,
        size: "small",
        color: m.value
      }, null, 8, ["color"])) : o.icon ? (t(), i(e(l), {
        key: 1,
        icon: o.icon,
        size: z.value
      }, null, 8, ["icon", "size"])) : (t(), p(h, { key: 2 }, [
        o.isLoading ? (t(), i(e(u), {
          key: 0,
          size: "small",
          color: m.value,
          absolute: !0
        }, null, 8, ["color"])) : r("", !0),
        o.leftIcon ? (t(), i(e(l), {
          key: 1,
          class: "button-icon",
          icon: o.leftIcon,
          size: s.value
        }, null, 8, ["icon", "size"])) : r("", !0),
        k("span", E, [
          C(c.$slots, "default", {}, void 0, !0)
        ]),
        o.rightIcon ? (t(), i(e(l), {
          key: 2,
          class: "button-icon",
          icon: o.rightIcon,
          size: s.value
        }, null, 8, ["icon", "size"])) : r("", !0)
      ], 64))
    ], 10, L));
  }
});
export {
  go as default
};
